<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-title color="white">Galleria eventi</ion-title>
        <ion-buttons @click="openMenu()" slot="start">
          <ion-button>
            <ion-icon :icon="menu" slot="start"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <div class="page_content">
        <div v-if="loading" class="loading_spinner">
          <ion-spinner name="crescent"></ion-spinner>
        </div>
        <div v-else>
          <div v-if="eventsWithGallery.length === 0" class="empty_events">
            Nessun evento con galleria immagini
          </div>
          <div v-else class="gallery_list">
            <div v-for="event in eventsWithGallery" :key="event.events_id" class="event_card"
              @click="openGalleryDetail(event)">
              <div class="fake_border" :style="{ backgroundColor: event.events_box_color || '#086fa3' }"></div>
              <div class="gallery_thumb">
                <img v-if="getFirstGalleryImage(event)" :src="getFirstGalleryImage(event)" alt="thumb" />
                <div v-else class="no_image">Nessuna immagine</div>
              </div>
              <div class="card_info">
                <div class="title">{{ event.events_title }}</div>
                <div class="date">{{ dateFormat(event.events_date_start) }}, {{ timeFormat(event.events_date_start) }} -
                  {{ timeFormat(event.events_date_end) }}</div>
                <div v-if="event.events_requires_confirmation && event.partecipants_count" class="partecipants_count">
                  <font-awesome-icon :icon="['fas', 'users']" style="color: #7f8085; font-size: 12px;" />
                  <span>{{ event.partecipants_count && event.partecipants_count > 0 ? event.partecipants_count : ''
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>

  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonSpinner, menuController, IonButtons, IonButton, IonIcon, modalController } from "@ionic/vue";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { menu } from "ionicons/icons";
import { LOCALSTORAGE_KEY } from "@/custom_config";
import apiCalendario from "@/services/calendario";
import { dateFormat, timeFormat } from "@/services/utils";
import moment from "moment";
import EventGalleryDetail from "@/components/event/EventGalleryDetail.vue";

export default {
  name: "GalleriaEventi",
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSpinner,
    IonButtons,
    IonButton,
    IonIcon,
  },
  setup() {
    const loading = ref(true);
    const eventsWithGallery = ref([]);
    const router = useRouter();
    const openMenu = () => {
      menuController.open("app-menu");
    };

    async function loadEvents() {
      loading.value = true;
      try {
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;
        // Prendi eventi da 1 anno fa a 1 anno dopo oggi
        const startDate = moment().subtract(1, 'year').format('YYYY-MM-DD');
        const endDate = moment().add(1, 'year').format('YYYY-MM-DD');

        const res = await apiCalendario.getEvents(userID, startDate, endDate);

        let events = [];
        if (res.status === 200 && res.data.status === 0) {
          events = res.data.data;
        }

        eventsWithGallery.value = events.filter(ev => {
          if (!ev.events_gallery) return false;
          let galleryArr = [];
          try {
            galleryArr = JSON.parse(ev.events_gallery);
          } catch (e) {
            return false;
          }
          return Array.isArray(galleryArr) && galleryArr.length > 0;
        });
        
      } catch (e) {
        eventsWithGallery.value = [];
      } finally {
        loading.value = false;
      }
    }

    function getFirstGalleryImage(event) {
      if (!event.events_gallery) return null;
      let galleryArr = [];
      try {
        galleryArr = JSON.parse(event.events_gallery);
      } catch (e) {
        return null;
      }
      if (Array.isArray(galleryArr) && galleryArr.length > 0) {
        const img = galleryArr[0];
        if (img && img.path_local) {
          return `${process.env.VUE_APP_BASE_URL}/uploads/${img.path_local}`;
        }
      }
      return null;
    }

    async function openGalleryDetail(event) {
      const modal = await modalController.create({
        component: EventGalleryDetail,
        componentProps: {
          data: event,
          id: event.events_id
        },
      });
      return modal.present();
    }

    onMounted(() => {
      loadEvents();
    });

    return {
      loading,
      eventsWithGallery,
      getFirstGalleryImage,
      openGalleryDetail,
      dateFormat,
      timeFormat,
      openMenu,
      menu,
    };
  },
};
</script>

<style scoped>
ion-toolbar {
  --background: #086fa3;
  --color: #ffffff;
}
ion-button {
    --color: #ffffff;
}
.loading_spinner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page_content {
  width: 100%;
  padding: 16px;
  min-height: 100%;
  background: #f2f2f2;
}

.loading_spinner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty_events {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgb(226 232 240);
  color: rgb(148 163 184);
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
}

.gallery_list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.event_card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px 0 #0001;
  padding: 12px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  margin-bottom: 8px;
}

.event_card:hover {
  box-shadow: 0 4px 12px 0 #0002;
}

.fake_border {
  width: 8px;
  border-radius: 4px;
  height: 64px;
  margin-right: 12px;
}

.gallery_thumb {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.gallery_thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.no_image {
  color: #aaa;
  font-size: 12px;
  text-align: center;
}

.card_info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
}

.date {
  font-size: 13px;
  color: #666;
}

.partecipants_count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #7f8085;
}
</style>